import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Medications from "./pages/Medications";
import MedicalProcedures from "./pages/MedicalProcedures";
import NonInvasiveDevices from "./pages/NonInvasiveDevices";
import Therapies from "./pages/Therapies";
import Nutrition from "./pages/Nutrition";
import AlternativeTreatment from "./pages/alternativetreatments";
import Sleep from "./pages/sleep";
import BrainTraining from "./pages/braintraining";
import Imaging from "./pages/imaging";
import "./App.css";
import SearchBar from "./components/SearchBar";
import Disclaimer from "./components/Disclaimer";
import MissionModal from "./components/MissionModal";
import Register from "./components/Register";
import EmailSignup from "./components/EmailSignup";
import FeedbackForm from "./components/FeedbackForm";
import PersonalizedPage from "./pages/PersonalizedPage";
import ProfilePage from "./pages/ProfilePage";
import LoginModal from "./components/LoginModal"; // <-- restored login modal
import ProfileMenu from "./components/ProfileMenu";
import About from "./pages/About";
import LaunchPage from "./pages/LaunchPage";

const categories = [
  { name: "Medications", path: "/medications", description: "Explore research-backed medications commonly prescribed for chronic pain." },
  { name: "Medical Procedures", path: "/medical-procedures", description: "Learn about medical procedures for pain relief, and what research shows about the effectiveness, risks and lasting impact." },
  { name: "Non-Surgical Treatments", path: "/therapies", description: "Discover non-invasive, often overlooked, treatments that effectively target chronic pain through feedback and signal disruption." },
  { name: "Medical Devices", path: "/non-invasive-devices", description: "Learn how non-invasive medical devices target nerves and inflammation to heal chronic pain." },
  { name: "Alternative Therapies", path: "/alternative-treatments", description: "Investigate holistic and complementary therapies for pain management." },
  { name: "Nutrition", path: "/nutrition", description: "Explore how diet, gut health, and targeted supplements affect inflammation and chronic pain." },
  { name: "Sleep Treatments", path: "/sleep", description: "Learn how sleep quality affects pain and find strategies to improve rest." },
  { name: "Mind-Body & Biofeedback", path: "/braintrain", description: "Learn how mental techniques and biofeedback can calm pain signals and improve control." },
  { name: "Diagnostic Procedures", path: "/imaging", description: "Learn how imaging and diagnostic procedures can help find root causes to your pain." },
];



function App() {
  const [showMission, setShowMission] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [showLogin, setShowLogin] = useState(false); // <-- modal visibility
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // Mission popup (unchanged)
  useEffect(() => {
    const alreadyShown = sessionStorage.getItem("missionShown");
    if (!alreadyShown) {
      const timer = setTimeout(() => {
        setShowMission(true);
        sessionStorage.setItem("missionShown", "true");
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  // Restore user from localStorage
  useEffect(() => {
    const stored = localStorage.getItem("user");
    if (stored) {
      setUser(JSON.parse(stored));
    }
  }, []);

  const doLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    window.location.reload();
  };

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <div style={{ background: "#d1e8fd", display: "flex", flexDirection: "column", alignItems: "center" }}>
                {/* Breadcrumb row */}
                <div
                  style={{
                    maxWidth: "1090px",
                    width: "90%",
                    margin: "24px auto -10px",
                    padding: "0 20px",
                    display: "flex",
                    justifyContent: "flex-end", 
                    alignItems: "center",
                    boxSizing: "border-box",
                  }}
                >
                 

                 {user ? (
                  <ProfileMenu
                    user={user}
                    onProfile={() => navigate("/profile")}
                    onLogout={doLogout}
                  />
                ) : (
                  <button className="nav-button" onClick={() => setShowLogin(true)}>
                    Login
                  </button>
                )}

                </div>

                {/* White top nav */}
                <div className="top-nav" style={{ width: "90%", maxWidth: "1020px" }}>
                <div className="nav-left" style={{ display: "flex", gap: 12 }}>
                  {!user && (
                    <button className="nav-button contact" onClick={() => setShowSignup(true)}>
                      Stay Informed
                    </button>
                  )}

                  {user && (
                    <button
                      className="nav-button nav-button-explore"
                      onClick={() => navigate("/personalized")}
                    >
                      My Research & Treatments
                    </button>
                  )}
                </div>

                <div className="mobile-button-row" style={{ gap: 12 }}>
                  <button className="nav-button contact" onClick={() => setShowFeedback(true)}>
                    Give Feedback
                  </button>
                  <button className="nav-button back" onClick={() => navigate("/about")}>
                    About
                  </button>

                </div>
              </div>
                  {/* === COMPACT FEEDBACK NOTICE ABOVE MAIN CONTENT === */}
                <div className="feedback-strip">
                What you’ve gone through matters. Please <strong>Give Feedback</strong> above to share what treatment helped or hasn’t. 
                Every story helps our research team grow this project into something more useful, more accurate, and more hopeful for others living with pain.
              </div>

              </div>
                  
              {/* Main content */}
              <div className="home-wrapper">
                

                <div className="home-container">
                  <h1>Welcome to Horizons: <br /> Your Chronic Pain Resource Hub</h1>
                  <p>Your trusted guide for evidence-based treatments and insights.</p>
                  <SearchBar />

                  <div className="category-grid">
                    {categories.map((category) => (
                      <Link key={category.name} to={category.path} className="category-card">
                        <h3>{category.name}</h3>
                        <p className="category-description">{category.description}</p>
                      </Link>
                    ))}
                  </div>

                  <Disclaimer />
                </div>

                {showMission && <MissionModal onClose={() => setShowMission(false)} />}

                {showSignup && (
                  <div className="modal-overlay">
                    <div className="modal-content">
                      <button className="close-button" onClick={() => setShowSignup(false)}>×</button>
                      <EmailSignup />
                    </div>
                  </div>
                )}

                {showFeedback && (
                  <div className="modal-overlay">
                    <div className="modal-content">
                      <button className="close-button" onClick={() => setShowFeedback(false)}>×</button>
                      <FeedbackForm />
                    </div>
                  </div>
                )}

                {/* LOGIN MODAL */}
                {showLogin && (
                  <LoginModal
                    onClose={() => setShowLogin(false)}
                    onLogin={(userData) => {
                      setUser(userData);
                      setShowLogin(false); // close modal, stay on page
                    }}
                  />
                )}
              </div>
            </>
          }
        />
        <Route path="/medications" element={<Medications />} />
        <Route path="/medical-procedures" element={<MedicalProcedures />} />
        <Route path="/non-invasive-devices" element={<NonInvasiveDevices />} />
        <Route path="/therapies" element={<Therapies />} />
        <Route path="/nutrition" element={<Nutrition />} />
        <Route path="/alternative-treatments" element={<AlternativeTreatment />} />
        <Route path="/sleep" element={<Sleep />} />
        <Route path="/braintrain" element={<BrainTraining />} />
        <Route path="/imaging" element={<Imaging />} />
        <Route path="/register" element={<Register onRegister={(userData) => setUser(userData)} />} />
        <Route path="/personalized" element={<PersonalizedPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/launch" element={<LaunchPage setShowLogin={setShowLogin} />} />

      </Routes>
    </>
  );
}

export default function WrappedApp() {
  return (
    <Router>
      <App />
    </Router>
  );
}
